import { render, staticRenderFns } from "./CoverHolder.vue?vue&type=template&id=0881a15c&"
import script from "./CoverHolder.vue?vue&type=script&lang=js&"
export * from "./CoverHolder.vue?vue&type=script&lang=js&"
import style0 from "./CoverHolder.vue?vue&type=style&index=0&id=0881a15c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports